var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStormTracksAndTornadoesSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_721_311)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H36C38.2091 0 40 1.79086 40 4V36C40 38.2091 38.2091 40 36 40H4C1.79086 40 0 38.2091 0 36V4Z",
    fill: "#1C53EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9467 5.44336C27.8114 5.44336 31.0065 8.3107 31.5287 12.0341C34.4911 12.1421 36.8549 14.5725 36.8549 17.5615C36.8548 20.6192 34.3805 23.0938 31.3227 23.0938H17.8207L17.8061 23.0928C14.1634 22.9717 11.2495 19.9761 11.2495 16.3056C11.2495 12.8558 13.8166 10.0181 17.142 9.57813C18.4176 7.12003 20.9803 5.44343 23.9467 5.44336Z",
    fill: "#1C53EC",
    stroke: "white",
    strokeWidth: 1.75624,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9829 20.6253C22.9829 17.4993 18.5074 14.9688 12.98 14.9688C7.46249 14.9589 2.97705 17.4993 2.97705 20.6253C2.97705 21.3001 3.19537 21.955 3.59231 22.5603L9.74491 33.3175C10.1518 34.032 10.7373 34.6571 11.4716 35.0243C11.5808 35.0739 11.69 35.1335 11.809 35.1732C12.1663 35.322 12.5136 35.4014 12.8411 35.4113C12.8907 35.4113 12.9502 35.4113 13.0098 35.4113C13.0693 35.4113 13.1189 35.4113 13.1785 35.4113C13.506 35.4014 13.8533 35.322 14.2105 35.1732C14.3296 35.1235 14.4388 35.0739 14.5479 35.0243C15.2823 34.6571 15.8578 34.032 16.2746 33.3175L22.3875 22.5603C22.7646 21.955 22.9829 21.3001 22.9829 20.6253Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.19489,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.98 25.8061C17.5563 25.8061 21.2661 23.7268 21.2661 21.1619C21.2661 18.5969 17.5563 16.5176 12.98 16.5176C8.40369 16.5176 4.69385 18.5969 4.69385 21.1619C4.69385 23.7268 8.40369 25.8061 12.98 25.8061Z",
    stroke: "#1C53EC",
    strokeWidth: 1.27272,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6562 26.2226C18.1601 27.5821 15.8082 28.6042 12.98 28.6042C9.79448 28.6042 7.21436 27.3043 7.21436 25.6966C7.21436 24.089 9.79448 22.7891 12.98 22.7891C14.667 22.7891 16.1754 23.1562 17.2372 23.7318",
    stroke: "#1C53EC",
    strokeWidth: 1.27272,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8997 29.5957C16.2349 30.6178 14.7265 31.3323 12.97 31.3323C11.67 31.3323 10.499 30.9353 9.71509 30.3201",
    stroke: "#1C53EC",
    strokeWidth: 1.27272,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.84509 23.5225C6.33135 21.2699 9.29849 19.5332 12.8908 19.5332C15.6991 19.5332 18.1304 20.5951 19.2815 22.1332",
    stroke: "#1C53EC",
    strokeWidth: 1.27272,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.19971 22.748L10.3004 31.5601C10.6378 32.1456 11.124 32.6517 11.7294 32.9593C12.3843 33.2868 13.2775 33.4852 14.2301 32.9791",
    stroke: "#1C53EC",
    strokeWidth: 1.27272,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7333 19.6702C28.1696 19.2087 28.867 19.0755 29.4482 19.3674L29.5634 19.4319L29.6865 19.5169C30.2726 19.9685 30.434 20.8007 30.0351 21.4436L28.0663 24.6165H30.6982C31.1787 24.6167 31.6222 24.8536 31.8925 25.2385L31.998 25.4124L32.0771 25.5999C32.2313 26.0446 32.1632 26.543 31.8818 26.9329L28.2216 32.0042C27.75 32.6576 26.8375 32.8053 26.1835 32.3342C25.5305 31.8628 25.381 30.9505 25.8525 30.2962L27.8437 27.5374H25.4394C24.9097 27.5373 24.4208 27.2507 24.163 26.7874C23.9067 26.3255 23.9194 25.7591 24.1982 25.3088L27.5536 19.9026L27.6015 19.8342L27.6835 19.7288C27.6992 19.7086 27.7158 19.6888 27.7333 19.6702Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7944 20.7266L25.4399 26.1312H30.698L27.0373 31.2029",
    stroke: "#1C53EC",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_721_311"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStormTracksAndTornadoesSelected);
export default __webpack_public_path__ + "static/media/storm-tracks-and-tornadoes-selected.cced26992fc42fbfda2f20f17856931c.svg";
export { ForwardRef as ReactComponent };